export enum ForexOperationType {
	BUY = 'BUY',
	SELL = 'SELL',
	ALL = 'ALL',
}

export interface ForexCount {
	template: number
	draft: number
}

export type ForexOperationTypeIndex = {
	[P in ForexOperationType]: number
}

export type ForexFilterHandlers = {
	[P in any]?: (value: any) => void
}
